import { emptyStyle } from "../constants";
import { isEqual } from "../helpers/other";
import { IStyle } from "./../types";
import { TextNode } from "./TextNode";

export enum SplitResult {
	invalidNode,
	offsetStart,
	offsetEnd,
	complete,
}

export class Block {
	public style: IStyle;

	public textNodes: TextNode[];

	constructor(textNodes?: TextNode[], style?: IStyle) {
		this.style = style || emptyStyle;
		if (!textNodes || textNodes.length === 0) {
			this.clear();
		} else {
			this.textNodes = textNodes;
		}
	}
	clear() {
		this.textNodes = [new TextNode("", emptyStyle)];
	}
	isEmpty() {
		return this.textNodes.length === 1 && this.textNodes[0].isEmpty();
	}
	splitTextNode(index: number, offset: number): SplitResult {
		const textNode = this.textNodes[index];
		if (!textNode) {
			return SplitResult.invalidNode;
		}

		if (offset === 0) {
			return SplitResult.offsetStart;
		}

		if (offset >= textNode.text.length) {
			return SplitResult.offsetEnd;
		}

		const text = textNode.text.slice(0, offset);
		const newText = textNode.text.slice(offset);
		const newTextNode = new TextNode(newText, textNode.style);
		textNode.text = text;

		this.textNodes.splice(index + 1, 0, newTextNode);
		return SplitResult.complete;
	}
	removeNodes(index: number, left?: boolean): boolean {
		// true need to remove all block, false - partial remove
		// for right selection -> remove from 0 to index
		// for left selection -> remove from index to end
		if (left) {
			if (index === 0) {
				return true;
			}

			this.textNodes = this.textNodes.slice(0, index);
			return false;
		}
		if (index === this.textNodes.length - 1) {
			return true;
		}
		this.textNodes = this.textNodes.slice(index + 1);
		return false;
	}
	offsetToNodePosition(offset) {
		if (offset === 0) {
			return {
				textIndex: 0,
				offset: 0,
			};
		}

		const textNodes = this.textNodes;

		for (let i = 0; i < textNodes.length; i++) {
			const len = textNodes[i].text.length;
			if (offset <= len) {
				return {
					textIndex: i,
					offset,
				};
			}
			offset -= len;
		}
	}
	nodePositionToOffset(textIndex, offset) {
		for (let i = 0; i < textIndex; i++) {
			offset += this.textNodes[i].text.length;
		}
		return offset;
	}
	getBlockEnd() {
		return {
			textIndex: this.textNodes.length - 1,
			offset: this.textNodes[this.textNodes.length - 1].text.length,
		};
	}
	balance(): boolean {
		// return true if changed
		const textNodes = this.textNodes;
		const len = textNodes.length;
		let index = 1;
		while (index < textNodes.length) {
			if (isEqual(textNodes[index - 1].style, textNodes[index].style)) {
				textNodes[index - 1].text += textNodes[index].text;
				textNodes.splice(index, 1);
			} else {
				index++;
			}
		}
		return len !== textNodes.length;
	}
}
